// cookie-settings-link.js
(function () {
  function openConsentPrefs() {
    // OneTrust / Optanon variants
    if (window.OneTrust?.ToggleInfoDisplay) { OneTrust.ToggleInfoDisplay(); return true; }
    if (window.Optanon?.ToggleInfoDisplay)  { Optanon.ToggleInfoDisplay();  return true; }
    // Truyo (if present on some stores)
    if (window.TruyoConsent?.openPreferences) { TruyoConsent.openPreferences(); return true; }
    // Fallback: click any existing vendor trigger if present
    var btn = document.getElementById('ot-sdk-btn')
          || document.querySelector('.ot-sdk-show-settings, .optanon-show-settings, .cookieSettingButton');
    if (btn) { btn.click(); return true; }
    console.warn('[Cookie Settings] Consent opener not found.');
    return false;
  }

  function isCookieSettingsLink(a) {
    if (!a || a.tagName !== 'A') return false;
    const text = (a.textContent || '').trim().toLowerCase();
    const href  = (a.getAttribute('href') || '').trim().toLowerCase();
    return a.hasAttribute('data-cookie-settings') || text === 'cookie settings' || href === '#cookie-settings' || href === '#';
  }

  document.addEventListener('DOMContentLoaded', function () {
    // Enhance menu anchors that read "Cookie Settings"
    document.querySelectorAll('a.footer-menu-links, a').forEach(function(a){
      if (/^\s*cookie\s*settings\s*$/i.test(a.textContent || '')) {
        a.classList.add('ot-sdk-show-settings', 'optanon-show-settings');
        if (!a.getAttribute('href') || a.getAttribute('href') === '#') a.setAttribute('href', '#cookie-settings');
        // Optional: give a unique ID only if you won't have duplicates
        // a.id = 'ot-sdk-btn';
        a.setAttribute('data-cookie-settings', '');
      }
    });

    // Also support a direct ID link if you have one elsewhere
    var direct = document.getElementById('cookie-settings-link');
    if (direct) {
      direct.addEventListener('click', function (e) {
        e.preventDefault();
        openConsentPrefs();
      });
    }
  });

  // Delegated click (covers header/footer/mega menus dynamically)
  document.addEventListener('click', function (e) {
    const a = e.target.closest('a');
    if (!isCookieSettingsLink(a)) return;
    e.preventDefault();
    openConsentPrefs();
  }, true);

  // Space key activation for accessibility
  document.addEventListener('keydown', function (e) {
    if (e.key !== ' ') return;
    const a = e.target.closest('a');
    if (!isCookieSettingsLink(a)) return;
    e.preventDefault();
    openConsentPrefs();
  });
})();
